import axiosConfig from "./axiosConfig";
import { PromptAddendumModel } from "./getLandlordResearchPrompt";
import { OutreachInputItem } from "./postOutreachDraft";

// Test a DRAFT outreach prompt against a real lead without saving anything. Unlike
// the landlord / people prompt tests (which kick off a long-running worker), drafting
// is one synchronous Bedrock call, so the BE returns the draft inline. The subject is
// always a promoted lead id (an outreach email needs an enriched contact); the BE
// appends the fixed guardrail before running, exactly as a save of this draft would.
export interface OutreachPromptTestRequest {
  addendum: PromptAddendumModel;
  subjectRef: string;
}

export interface OutreachPromptTestResponse {
  // "complete" on success, or a reason the test could not run
  // (e.g. "no_contact", "not_found").
  status: string;
  subject?: string;
  body?: string;
  inputs?: OutreachInputItem[];
  // The trace is stored under a synthetic ref for this ephemeral test run.
  traceSubjectRef?: string;
  traceRunId?: string;
}

const postOutreachPromptTest = async (
  authToken: string,
  body: OutreachPromptTestRequest
): Promise<OutreachPromptTestResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/ai-prompt/test`,
    { ...body, task: "outreach_email", subjectKind: "lead" },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postOutreachPromptTest;
